import React from "react";
import { Link } from "react-router-dom-v5-compat";
import classNames from "classnames";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  danger?: boolean;
  link?: boolean;
  success?: boolean;
  children: React.ReactNode;
  className?: string;
}

interface LinkButtonProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  primary?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  danger?: boolean;
  link?: boolean;
  success?: boolean;
  children?: React.ReactNode;
  className?: string;
}
export const LinkButton = ({
  primary,
  secondary,
  tertiary,
  danger,
  link,
  success,
  children,
  className,
  to,
  ...props
}: LinkButtonProps) => (
  <Link
    className={classNames(className, "btn no-underline", {
      primary:
        primary || !(primary || secondary || tertiary || link || success),
      secondary,
      tertiary,
      link,
      danger,
      success,
    })}
    to={to}
    {...props}
  >
    {children}
  </Link>
);

export const Button = ({
  primary,
  secondary,
  tertiary,
  link,
  danger,
  success,
  children,
  className,
  ...props
}: ButtonProps) => (
  <button
    className={classNames(className, "btn", {
      primary:
        primary || !(primary || secondary || tertiary || link || success),
      secondary,
      tertiary,
      link,
      danger,
      success,
    })}
    {...props}
  >
    {children}
  </button>
);

export default Button;
